<script setup>
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/add-round.svg';

defineProps({
    href: {
        type: [String, URL],
        required: false,
        default: undefined,
    },
});
</script>

<template>
    <Component
        :is="href ? 'a' : 'button'"
        :href="href"
        class="jix-add-inline"
    >
        <SvgIcon
            name="add-round"
            size="xs"
            role="presentation"
            class="mr-1"
        />
        <slot />
    </Component>
</template>
